<template>
  <v-app class="custom__bg">
    <v-container>
      <v-row justify="center " align="center" class="mt-12">
        <v-col cols="12" md="12">
          <div class="d-flex justify-center align-center ">
            <img
              src="../assets/bglogo.svg"
              alt="logo"
              width="200"
              class=""
            />
          </div>
        </v-col>
        

        <div
          class="d-flex justify-center align-center progress__container mt-5"
        >
          <v-progress-linear
            color="#f69227"
            indeterminate
            interval="0"
            rounded
            height="4"
          ></v-progress-linear>
        </div>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
export default {
  created() {
    setTimeout(() => {
      this.$router.push({ path: "/option" });
    }, 1000);
  },
};
</script>

<style scoped>
.custom__bg {
  background: #f7f9fb;
}
.progress__container {
  width: 150px;
}
</style>
